// Third-party
import { createSelector } from '@reduxjs/toolkit';

// Utils
import { getComparisonFilteredItems } from '../../../utils/comparison';

// Types
import { COMPARISON_ITEM_TYPES } from '../../../utils/constants';
import { ComparisonState } from '../types/comparison';
import ComparisonItem from '@/types/comparison-item';
import { ReduxState } from '../types';

const selectComparison = (state: ComparisonState) => state.activeComparison;
const selectComparisonItemsFilter = (state: ComparisonState) => state.itemsFilter;
export const selectActiveComparison = (state: ReduxState) => state.comparison.activeComparison;

export const selectSelectedHistoricalScenarios = createSelector(
  [selectActiveComparison],
  activeComparison => activeComparison?.selectedHistoricalScenarios || [],
);

export const selectActiveComparisonItems = createSelector([selectActiveComparison], activeComparison => activeComparison?.items || []);

export const selectComparisonWithFilteredItems = createSelector([selectComparison, selectComparisonItemsFilter], (comparison, filter) => {
  if (!comparison) {
    return comparison;
  }

  const filteredItems = getComparisonFilteredItems(comparison, filter);
  const groups = comparison.items.filter(item => item.type === COMPARISON_ITEM_TYPES.GROUP);

  return {
    ...comparison,
    items: filteredItems.map(item => {
      if (item.type === COMPARISON_ITEM_TYPES.GROUP) {
        return item;
      }

      const itemGroups = groups.filter(group => group.groupItems?.some(i => i.itemId === item._id));

      return {
        ...item,
        groups: itemGroups.map(group => ({
          name: group.name,
          itemId: group._id,
          color: group.color,
        })),
      } as ComparisonItem;
    }),
  };
});
